export const LAB_TYPE = 'lab'
export const IMAGE_TYPE = 'image'
export const WBP_TYPE = 'wbp'
